import { render, staticRenderFns } from "./IstanbulTravel.vue?vue&type=template&id=6b1abb80&"
import script from "./IstanbulTravel.vue?vue&type=script&lang=js&"
export * from "./IstanbulTravel.vue?vue&type=script&lang=js&"
import style0 from "./IstanbulTravel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IstanbulTravel.vue"
export default component.exports